<template>
  <div v-if="currentUser" class="settings">
    <header class="view-header">
      <div class="view-header__text">
        <h1 class="view-header__title">Preferencias</h1>
        <p class="view-header__sub">
          Administra tu cuenta y los datos de la inmobiliaria.
        </p>
      </div>
    </header>

    <Edit :currentUser="currentUser" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Edit from '@/components/settings/Edit'

export default {
  computed: {
    ...mapGetters(['currentUser'])
  },

  components: {
    Edit
  }
}
</script>

<style scoped>
.settings {
  background: #f7f5f1;
  min-height: 100%;
}

.view-header {
  margin-bottom: 18px;
}
.view-header__title {
  font-size: 26px;
  font-weight: 700;
  line-height: 1.1;
  color: #1a1814;
  margin: 0;
}
.view-header__sub {
  font-size: 13.5px;
  color: #756f64;
  margin: 5px 0 0;
}
</style>
